module.exports = __webpack_public_path__ + "img/CPT02.ed2e840d.svg";